import React from "react";
import { cn } from "@/lib/utils";

export default function BrandLogo({ className, imgClassName, alt = "StayServe", ...props }) {
  return (
    <img
      src="/assets/logo.png"
      alt={alt}
      className={cn("h-auto w-auto object-contain select-none", className)}
      draggable={false}
      {...props}
    />
  );
}
